// import { debouncer, documentReady } from "../Utility/utils";
import Flickity from "flickity";
import "flickity/dist/flickity.min.css";

const initializeBlock = function( $block ){
  // First, Determine which block we're in, and set the args accordingly.
  let slider;
  let args;

  // For backend, ensure we're targeting the actual block.
  if(!!$block[0]){
    $block = $block[0];
  }

  // Default Slider Block
  if(!!$block.querySelector('.articles-slider__slider')){
    slider = $block.querySelector('.articles-slider__slider');
    var flkty = new Flickity( slider, {
      // options
      prevNextButtons: false,
      freeScroll: true,
      // wrapAround: true,
      groupCells: 1,
      cellAlign: 'left',
      // draggable: false,
    });

    // changes slides based on mouse coordinates
    // var sliderWidth = slider.getBoundingClientRect().width;
    // var oldX = 0;
    // mouseDirection = function (e) {

    //     if ( e.pageX < oldX ) {
    //         // left
    //         console.log('left');
    //     } else if ( e.pageX > oldX ) {
    //         // right
    //         console.log('right');
    //     }
    //     oldX = e.pageX;
    // }

    // slider.addEventListener('mousemove', mouseDirection);

  }
}


// Initialize the slider on the front end
window.addEventListener('load', function(){
  var slider = document.querySelector('.articles-slider');
  if(!!slider){
    initializeBlock(slider);
  }
});


// Initialize dynamic block preview (editor).
if( window.acf ) {
  window.acf.addAction( 'render_block_preview/type=articles-slider', initializeBlock );
}
